
import { Search } from 'vant';
import { jsSdk } from '../../../assets/libs/loadjs';

export default {
  name: 'home',
  components: {
    [Search.name]: Search
  },
  data () {
    return {
      customerName: this.$store.state.customerName || '',
    }
  },
  methods: {

  },
  mounted () {
    // 显示部分功能按钮
    // jsSdk(this.$store.state.customer, ['showMenuItems']).then(function(){
    //   wx.showMenuItems({
    //     menuList: [
    //       'menuItem:share:appMessage', //发送给朋友
    //       'menuItem:share:timeline', //分享到朋友圈
    //       'menuItem:share:qq', //分享到QQ
    //       'menuItem:share:weiboApp', // 分享到Weibo
    //       'menuItem:share:QZone', // 分享到QQ空间
    //       'menuItem:favorite', // 收藏
    //     ],
    //     success: function (res) {
    //       console.log('已显示部分功能按钮About');
    //     },
    //     fail:function(res){
    //       // alert('fail:' + JSON.stringify(res));
    //     }
    //   });
    // });
  },
  created () {
    window.scrollTo(0,0);
  }
}
